import axios from 'axios';
import { getDeviceToken } from '../utils/deviceFingerprint';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Ajouter le device token pour le tracking de sécurité
    const deviceToken = getDeviceToken();
    config.headers['X-Device-Token'] = deviceToken;
    
    return config;
  },
  (error) => Promise.reject(error)
);

export const authAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (credentials) => api.post('/auth/login', credentials),
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
  getCurrentUser: () => api.get('/auth/me'),
};

export const subscriptionAPI = {
  getMySubscriptions: () => api.get('/subscriptions/my'),
  getAllSubscriptions: () => api.get('/admin/subscriptions'),
  updateSubscription: (id, data) => api.put(`/admin/subscriptions/${id}`, data),
};

export const iptvAPI = {
  getMyCredentials: () => api.get('/iptv-credentials/my'),
  createCredentials: (data) => api.post('/iptv-credentials', data),
  updateCredentials: (id, data) => api.put(`/iptv-credentials/${id}`, data),
};

export const paymentAPI = {
  createOrder: (orderData) => api.post('/payments/create-order', orderData),
  captureOrder: (orderId) => api.post(`/payments/capture/${orderId}`),
};

export const vendorAPI = {
  register: (vendorData) => api.post('/vendors/register', vendorData),
};

export const adminAPI = {
  getUsers: () => api.get('/admin/users'),
  getSubscriptions: () => api.get('/admin/subscriptions'),
};

export default api;